import { render } from "./BoardUser.vue?vue&type=template&id=ef16da6e"
import script from "./BoardUser.vue?vue&type=script&lang=js"
export * from "./BoardUser.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__